<template>
    <div class="view view__lms_superadmin_users_edit">
        <lms-superadmin-users-edit/>
    </div>
</template>

<script>
import LmsSuperadminUsersEdit from '@/components/lms/superadmin/users/edit/LmsSuperadminUsersEdit.vue'
import { allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect } from '@/helpers/mixins'
export default {
  name: 'view-lms-superadmin-user-edit',
  components: { LmsSuperadminUsersEdit },
  mixins: [allowRedirectBeforeRouteLeave, watchContentChangePreventRedirect],
  computed: {
    routeUserId: function () {
      return this.$route.params.userId
    }
  },
  methods: {
    getUser: function () {
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('lmsSuperadminUserGet', this.routeUserId).finally(() => {
        this.$eventBus.$emit('stop-loading')
      })
    },
    clearUser () {
      this.$store.dispatch('lmsSuperadminUserClear')
    }
  },
  created () {
    this.getUser()
  },
  mounted () {
    this.$eventBus.$on('user-submit', this.allowRedirect)
  },
  beforeDestroy () {
    this.$eventBus.$off('user-submit')
    this.clearUser()
  }
}
</script>
